export const DEFAULT_POLL_INTERVAL = 20e3
